import Box from 'components/layouts/Box';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';
import { AdminSystemLocaleDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useLocale } from 'providers/LocalProvider';
import { useStateContext } from 'providers/usePageState';

const SettingsMenus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [languages, setLanguages] = useState<AdminSystemLocaleDto[]>([]);
  const { receiver } = useStateContext();

  const fetchLanguages = async () => {
    ServiceHelper.adminLocaleService?.getLocales1().then((res) => {
      setLanguages(res.data as AdminSystemLocaleDto[]);
    });
  };

  const activeLanguagesCount = languages.filter((lang) => lang.isActive).length;

  const routes = [
    { route: `/admin/settings/business-list`, name: '사업자목록', children: '3곳의 사업자' },
    // {
    //   route: `/admin/settings/user-management`,
    //   name: '사용자관리',
    //   children: '5명의 등록된 사용자',
    // },
    // { route: `/admin/settings/language-settings`, name: '언어설정', children: '4개의 언어' },
    {
      route: `/admin/settings/language-settings`,
      name: '언어설정',
      children: `${activeLanguagesCount}개의 언어`,
    },
    {
      route: `/admin/settings/region-settings`,
      name: '지역설정',
      children: '10개의 지역',
    },
    // { route: `/admin/settings/custom-fields`, name: '커스텀필드', children: '3개의 커스텀필드' },

    // {
    //   route: `/admin/settings/tag-settings`,
    //   name: '태그',
    //   children: '태그 설정',
    // },
    // {
    //   route: `/admin/settings/amenities-settings`,
    //   name: '편의시설',
    //   children: '편의시설 설정',
    // },
    // { route: `/admin/settings/option-settings`, name: '옵션상품 설정', children: '옵션상품 설정' },
    // {
    //   route: `/admin/settings/places-settings`,
    //   name: '가볼만한 곳',
    //   children: '가볼만한 곳 설정',
    // },
  ];

  useEffect(() => {
    fetchLanguages();
  }, []);

  useEffect(() => {
    if (receiver?.id === 'reload' && receiver?.param === 'language') {
      fetchLanguages();
    }
  }, [receiver]);

  return (
    <div>
      <Row justifyContent="flex-start" padding="20px 0">
        <>설정</>
      </Row>
      <Row gap={10} flexDirection="column" width="100%">
        {routes.map((route) => (
          <div key={route.route} style={{ width: '300px' }}>
            <Box
              title={route.name}
              selected={location.pathname === route.route}
              onClick={() => navigate(route.route)}
            >
              <Text type="H5" buttonRole="DESCRIPTION">
                {route.children}
              </Text>
            </Box>
          </div>
        ))}
      </Row>
    </div>
  );
};

export default SettingsMenus;
